var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.excludeFromPrintClassName]},[_c('button',{on:{"click":_vm.downloadFile}},[_vm._v("Download PDF")])])
}
var staticRenderFns = []

export { render, staticRenderFns }